// extracted by mini-css-extract-plugin
export var activeDot = "_5n-c";
export var buttonContainer = "_5n-9";
export var channelButton = "_5n-a";
export var clickable = "_5n-d";
export var content = "_5n-0";
export var contentFull = "_5n-2";
export var contentThird = "_5n-1";
export var contentWrapper = "_5n-7";
export var description = "_5n-5";
export var heightShort = "_5n-f";
export var image = "_5n-3";
export var imageContainer = "_5n-4";
export var selectButton = "_5n-e";
export var spinnerContainer = "_5n-b";
export var titleContent = "_5n-8";
export var titleWrapper = "_5n-6";